module.exports = __webpack_public_path__ + "media/categories/2006-fa44f157.svg";